<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <!--<div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div>-->
                    <div class="card-body px-lg-5 py-lg-5">
                        <!--<div class="text-center text-muted mb-4">
                            <small>Or sign in with credentials</small>
                        </div>-->
                        <form role="form" @submit.prevent="login(email, password)">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="email">
                            </base-input>

                            <base-input class="input-group-alternative"
                                        placeholder="Password"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="password">
                            </base-input>

                            <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox>
                            <div class="text-center">
                                <base-button type="primary" nativeType="submit" class="my-4">Sign in</base-button>
                            </div>
                        </form>
                        <base-alert type="danger" dismissible v-if="loginError">
                          <span class="alert-inner--text"><strong>Whoops!</strong> {{ loginError }}</span>
                          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                        </base-alert>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <!--<a href="#" class="text-light"><small>Forgot password?</small></a>-->
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
	name: 'login',
	data() {
		return {
			email: '',
			password: '',
			loginError: false
		}
	},
	methods: {
		login (email, password) {
			this.loginError = false;
			this.$store
			.dispatch('auth/authenticate', {
				strategy: 'local',
				email,
				password
			})
			.then(() => {
				this.$router.push('/');
			})
			// Just use the returned error instead of mapping it from the store.
			.catch(err => {
				this.loginError = err.message;
			})
		}
	}
}
</script>
<style>
</style>
